// // useAuth.js
// import { useEffect } from 'react';
import { getJwtToken } from 'utils/functions/session-storage';

import AuthContext from 'context/AuthProvider';
import { useContext } from 'react';

// const useAuth = () => {
//   useEffect(() => {
//     const token = getJwtToken();
//     if (!token) {
//       // Redirect to login page or any other page if token is not present
//       window.location.href = 'login'; // Redirect to login page
//     }
//   }, []);

//   return;
// };

// export default useAuth;

export default function useAuthContext() {
  return useContext(AuthContext);
}
